import { ErrorCodes } from '~/Api/User/ProductGroup/CaLabeling/ErrorCodes';
import { ApiClientErrorResponse } from '~/ApiClient';

export class ErrorResponse extends ApiClientErrorResponse {
	handleProductGroupNotFound(): boolean {
		return this.handle('product-group-not-found');
	}

	handleProductGroupLocked(): boolean {
		return this.handle('product-group-locked');
	}

	handleCannotChangeSettingsForNonMemberProducts(): boolean {
		return this.handle(ErrorCodes.cannotChangeSettingsForNonMemberProducts);
	}
}
